import React, { useContext } from 'react';
import { useHistory } from 'react-router';
import { Avatar, Button, makeStyles, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { AppContext } from 'context';
import { SortingCenter } from 'types';
import Footer, { footerHeight } from 'components/Footer';
import Header from 'components/Header';
import { colors } from 'theme';
import { generateList } from './helper';

const useStyles = makeStyles(theme => ({
  avatar: {
    backgroundColor: 'transparent',
    border: '1px solid',
    color: theme.palette.primary.main,
    width: '3.5rem',
    height: '3.5rem',
    marginRight: '2rem',
    fontSize: '1.5rem',
  },
  content: {
    display: 'flex',
    minHeight: '100vh',
    position: 'absolute',
    top: '4.4rem',
    bottom: 0,
    left: 0,
    right: 0,
    paddingBottom: footerHeight,
    background: 'white',
  },
  left: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    padding: '5em',
    overflow: 'scroll',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '2em',
    marginBottom: '7em',
  },
  title: {
    fontSize: '32px',
    textTransform: 'uppercase',
    fontWeight: 600,
    lineHeight: '50px',
  },
  primary: {
    color: theme.palette.primary.main,
  },
  subtitle: {
    fontSize: '16px',
    fontWeight: 'normal',
  },
  right: {
    width: '30%',
    background:
      "repeating-linear-gradient( 135deg, transparent, transparent 10px, rgba(255, 255, 255, 1) 10px, rgba(255, 255, 255, 1) 12px), url('/home_aside_v2.png')",
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  link: {
    textTransform: 'uppercase',
    fontSize: '0.75rem',
    textDecoration: 'underline',
    color: colors.neutral800,
  },
  linkContainer: {
    position: 'absolute',
    bottom: 30,
    left: 30,
  },
  separator: {
    borderRight: `1px solid ${colors.neutral800}`,
    paddingRight: 7,
    marginRight: 7,
  },
  infoDisplay: {
    width: '165px',
    textTransform: 'capitalize',
  },
  linkAdmin: {
    textAlign: 'right',
    marginBottom: '2em',
  },
  adminButton: {
    fontWeight: 900,
    textAlign: 'right',
    textDecoration: 'underline',
    marginBottom: '2em',
    '&:hover': {
      color: theme.palette.primary.main,
      backgroundColor: 'rgba(0, 0, 0, 0)',
      textDecoration: 'underline',
    },
  },
}));

const SortingCenterSelectionPage: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const context = useContext(AppContext);
  const user = context.user;

  const history = useHistory();

  const selectSortingCenter = (sortingCenter: SortingCenter) => {
    context.setActiveSortingCenter?.(sortingCenter);
    history.push('/');
  };

  return (
    <>
      <Header />
      <div className={classes.content}>
        <div className={classes.left}>
          {user && (
            <>
              <div className={classes.header}>
                <Avatar className={classes.avatar}>
                  {user.firstName ? user.firstName[0] : user.email[0]}
                  {user.lastName ? user.lastName[0] : ''}
                </Avatar>
                <div>
                  <Typography variant="h1" className={classes.title}>
                    {t('sortingCenterSelection.title')}{' '}
                    <span className={classes.primary}>
                      {user.firstName} {user.lastName}
                    </span>
                  </Typography>
                  <Typography variant="h2" className={classes.subtitle}>
                    {t('sortingCenterSelection.subtitle')}
                  </Typography>
                </div>
              </div>
              {context.hasLeastOneAdminRole() && (
                <div className={classes.linkAdmin}>
                  <Button
                    className={classes.adminButton}
                    onClick={() => history.push('administration')}
                    variant="text"
                    color="default"
                    endIcon={<ArrowForwardIcon />}
                  >
                    {t('sortingCenterSelection.adminButton')}
                  </Button>
                </div>
              )}
              {generateList(user.sortingCenterUserRoles, selectSortingCenter)}
            </>
          )}
        </div>
        <aside className={classes.right}></aside>
      </div>
      <Footer />
      <div className={classes.linkContainer}>
        <Link
          to="/politique-de-confidentialite.pdf"
          target="_blank"
          download
          className={`${classes.link} ${classes.separator}`}
        >
          {t('privacyPolicy')}
        </Link>
        <Link to="/cgu.pdf" target="_blank" download className={classes.link}>
          {t('termsOfUse')}
        </Link>
      </div>
    </>
  );
};
export default SortingCenterSelectionPage;
